import api, { createCancelTokenHandler } from "../utils/services/api.service";
import { ENV } from "../constants";

const LeadRepository = {
  all(params?: any) {
    return api.get(`${ENV.getApiEndPoint()}/api/lead`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.all.name].handleRequestCancellation()
          .token,
    });
  },
  allCount(params?: any) {
    return api.get(`${ENV.getApiEndPoint()}/api/lead/count`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.allCount.name].handleRequestCancellation()
          .token,
    });
  },
  show(id: string, params?: any) {
    return api.get(`${ENV.getApiEndPoint()}/api/lead/${id}`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.show.name].handleRequestCancellation()
          .token,
    });
  },
  delete: function (id: number | string, params: any = null) {
    return api.delete(`${ENV.getApiEndPoint()}/api/lead/${id}`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.delete.name].handleRequestCancellation()
          .token,
    });
  },
  select: function (params: any = null) {
    return api.get(`${ENV.getApiEndPoint()}/api/select/lead`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.select.name].handleRequestCancellation()
          .token,
    });
  },
  create: function (payload: any, params: any = null) {
    return api.post(`${ENV.getApiEndPoint()}/api/lead`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.create.name].handleRequestCancellation()
          .token,
    });
  },
  update: function (id: number | string, payload: any, params: any = null) {
    return api.put(`${ENV.getApiEndPoint()}/api/lead/${id}`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.update.name].handleRequestCancellation()
          .token,
    });
  },
  activity: function (id: number | string, payload: any, params: any = null) {
    return api.put(`${ENV.getApiEndPoint()}/api/lead/${id}/activity`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.activity.name].handleRequestCancellation()
          .token,
    });
  },
  deleteActivity: function (
    id: number | string,
    activityId: number | string,
    params: any = null
  ) {
    return api.delete(
      `${ENV.getApiEndPoint()}/api/lead/${id}/activity/${activityId}`,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[
            this.deleteActivity.name
          ].handleRequestCancellation().token,
      }
    );
  },
};

const cancelTokenHandlerObject = createCancelTokenHandler(LeadRepository);

export default LeadRepository;
